import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-398eb6ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emergency-outhr-event-list-modal" }
const _hoisted_2 = { class: "emergency-outhr-event-list-modal__search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "emergency-outhr-event-list-modal__search-label" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Select issue")
], -1))
const _hoisted_4 = { class: "emergency-outhr-event-list-modal__inner" }
const _hoisted_5 = { class: "emergency-outhr-event-list-modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    class: "tw-max-w-[620px]",
    headerTitle: "Out of Hours",
    onOnClose: $setup.onCloseEmergencyListModal
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            placeholder: "Search Issue",
            "prepend-inner-icon": "mdi-magnify",
            modelValue: $setup.searchEOHEvent,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchEOHEvent) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_radio_group, {
            modelValue: $setup.selectEOHEvent,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectEOHEvent) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterEOHEvents, (event) => {
                return (_openBlock(), _createBlock(_component_v_radio, {
                  label: event?.emergencyOutOfHours?.title,
                  value: event?.emergencyOutOfHours?.id,
                  color: "#4B4BFF",
                  key: event?.emergencyOutOfHours?.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_btn, {
          class: "button button-purple-border",
          onClick: $setup.onCloseEmergencyListModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("CANCEL")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_btn, {
          class: "button button-orange",
          onClick: $setup.onClickNextButton,
          disabled: !$setup.selectEOHEvent
        }, {
          default: _withCtx(() => [
            _createTextVNode("Next")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}